import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
};
default_1 = __decorate([
    Component({
        name: 'no-data',
        i18n: {
            messages: {
                'en-us': {
                    noData: 'No Data',
                },
                zh: {
                    noData: '暂无数据',
                },
            },
        },
    })
], default_1);
export default default_1;
